module.exports = __webpack_public_path__ + "img/36.c28d5226.svg";